module.exports = __webpack_public_path__ + "static/media/id.0c2676eb.svg";